export const EMAIL_REGEX =
    '^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$';
export const PHONE_REGEX =
    '((?:\\+?3|0)6)(?:-|\\()?(\\d{1,2})(?:-|\\))?(\\d{3})-?(\\d{3,4})';
export const POSTAL_CODE_REGEX = '^([1-9][0-9]{3})$';
export const TAJ_REGEX = '^([0-9]{3}-[0-9]{3}-[0-9]{3})$';
export const CAN_NOT_START_WITH_WHITE_SPACE = '^[^\\s].*';
